module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" preserveAspectRatio=\"xMaxYMax meet\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"12.5\" cy=\"12.5\" r=\"12\" stroke=\"#FFF\" opacity=\".75\"/><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M17.8 9.75L16.56 11 14 8.44l1.25-1.24c.26-.27.7-.27.96 0l1.6 1.6c.26.25.26.7 0 .95zM13.73 9L16 11.27 9.29 18H7v-2.28L13.73 9z\" opacity=\".7\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/edit-circle.svg
// module id = Oylt
// module chunks = 5